import React from "react";
import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import MainTable from "./MainTable";
import BarChart from "../components/BarChart";
import HorizontalBarChart from "../components/HorizontalBarChart";
import DonutChart from "./DonutChart";
import {
  Tab,
  Tabs,
  Paper,
  Box,
  Stack,
  Grid,
  Typography,
  Tooltip,
} from "@mui/material/";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function BasicTabs(props) {
  const [value, setValue] = useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  // fetch number of measures
  var count = JSON.parse(sessionStorage.getItem('count'))//FetchRequest("count");

  const [selectedRows, setSelectedRows] = useState();
  const getSelectedRows = (data) => {
    // If... just to make sure that there is no misfire.
    if (selectedRows !== data) {
      setSelectedRows(data);
    }
  };

  useEffect(() => {
    props.selectedRows(selectedRows);
  });

  function hasContent(string) {
    return string ? string : "Not specified";
  }

  //check if measure_count data arrives and place it into object
  if (count !== null) {
    // Measure count objects
    var measure_number = count[0];
    var numbers = measure_number["measure_count"];
    

    return (
      <>
        <Box>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs
              value={value}
              indicatorColor="primary"
              centered
              onChange={handleChange}
              aria-label="tab buttons"
            >
              <Tooltip title="Measure table">
                <Tab label="Table" {...a11yProps(0)} />
              </Tooltip>
              <Tooltip title="Summary statistics">
                <Tab label="Summary Stats" {...a11yProps(1)} />
              </Tooltip>
            </Tabs>
          </Box>

          <TabPanel value={value} index={0}>
            <Paper>
              {/* get the selected row, passthrought selected country to only display rows of that country and passthrough wether or not the map is minimalized */}
              <MainTable
                selectedRows={getSelectedRows}
                selectedCountry={props.selectedCountry}
                boolMapMinimalized={props.mapMinimalized}
                selectedCat={props.selectedCat}
                selectedSubCat={props.selectedSubCat}
                selectedMeas={props.selectedMeas}
                selectedTitle={props.selectedTitle}
              />
            </Paper>
          </TabPanel>

          <TabPanel value={value} index={1}>
            <Grid
              container
              spacing={2}
              justifyContent="space-between"
              sx={{ marginBottom: 2 }}
            >
              <Grid item xs={6}>
                
              </Grid>

            </Grid>

            <Paper>
  
              <HorizontalBarChart
                     Country={props.selectedCountry}
                  />
                
            </Paper>
          </TabPanel>
        </Box>
      </>
    );
  }
  // This returns before the fetch request is complete
  return <span>Loading....</span>;
}

export default BasicTabs;
